export const DARK_BG = '#080809';
export const NOPING_GREEN = '#93FF18';
export const COMPETITOR_RED = '#EF4444';
export const ACCENT_BLUE = '#2ECDFF';
export const TEXT_LIGHT = '#E5E7EB';
export const MUTED_GRAY = '#929298';
export const CARD_DARK = '#111114';
export const SECTION_ALT = '#0A0A0D';

export const EASE_OUT = [0.25, 0.46, 0.45, 0.94] as const;

export const CHAMPIONS = [
  {
    name: 'Sacy',
    title: 'champion_sacy_title',
    game: 'Valorant',
    quote: 'champion_sacy_quote',
    accentGlow: '#FF4655',
    accentBg: 'rgba(255,70,85,0.08)',
    initial: 'S',
    image: '/images/players/sacy.webp',
  },
  {
    name: 'coldzera',
    title: 'champion_coldzera_title',
    game: 'CS2',
    quote: 'champion_coldzera_quote',
    accentGlow: '#F5A623',
    accentBg: 'rgba(245,166,35,0.08)',
    initial: 'C',
    image: '/images/players/coldzera.webp',
  },
  {
    name: 'BRTT',
    title: 'champion_brtt_title',
    game: 'League of Legends',
    quote: 'champion_brtt_quote',
    accentGlow: '#2ECDFF',
    accentBg: 'rgba(46,205,255,0.08)',
    initial: 'B',
    image: '/images/players/brtt.webp',
  },
] as const;

export const USER_REVIEWS = [
  { quote: 'review_0_quote', name: 'Jake M.', game: 'Valorant', stars: 5 },
  { quote: 'review_1_quote', name: 'Carlos R.', game: 'CS2', stars: 5 },
  { quote: 'review_2_quote', name: 'Sarah K.', game: 'Content Creator', stars: 5 },
  { quote: 'review_3_quote', name: 'Marcus T.', game: 'Apex Legends', stars: 5 },
  { quote: 'review_4_quote', name: 'David L.', game: 'Fortnite', stars: 5 },
  { quote: 'review_5_quote', name: 'Ana P.', game: 'FFXIV', stars: 5 },
  { quote: 'review_6_quote', name: 'Ryan W.', game: 'League of Legends', stars: 5 },
  { quote: 'review_7_quote', name: 'Lucas F.', game: 'CS2', stars: 5 },
  { quote: 'review_8_quote', name: 'Priya S.', game: 'Overwatch 2', stars: 5 },
] as const;

export const TICKER_STATS = [
  { value: '3,000,000+', label: 'ticker_active_users' },
  { value: '2,000+', label: 'ticker_global_servers' },
  { value: '150+', label: 'ticker_countries' },
  { value: '3,000+', label: 'ticker_games_supported' },
  { value: 'Up to 80%', label: 'ticker_ping_reduction' },
  { value: '110%', label: 'ticker_fps_increase' },
  { value: '100%', label: 'ticker_packet_loss_fix' },
] as const;

export const SWITCH_REASONS = [
  {
    title: 'switch_0_title',
    stat: 'Up to 80%',
    description: 'switch_0_description',
    iconPath: 'M13 2L3 14h9l-1 8 10-12h-9l1-8z',
    color: NOPING_GREEN,
  },
  {
    title: 'switch_1_title',
    stat: '+110%',
    description: 'switch_1_description',
    iconPath: 'M12 20V10M6 20v-4M18 20v-8',
    color: ACCENT_BLUE,
  },
  {
    title: 'switch_2_title',
    stat: '60s',
    description: 'switch_2_description',
    iconPath: 'M12 2a10 10 0 100 20 10 10 0 000-20zM8 12l2 2 4-4',
    color: NOPING_GREEN,
  },
  {
    title: 'switch_3_title',
    stat: '100%',
    description: 'switch_3_description',
    iconPath: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z',
    color: ACCENT_BLUE,
  },
  {
    title: 'switch_4_title',
    stat: 'All-in-1',
    description: 'switch_4_description',
    iconPath: 'M3 18v-6a9 9 0 0118 0v6M21 19a2 2 0 01-2 2h-1a2 2 0 01-2-2v-3a2 2 0 012-2h3zM3 19a2 2 0 002 2h1a2 2 0 002-2v-3a2 2 0 00-2-2H3z',
    color: NOPING_GREEN,
  },
  {
    title: 'switch_5_title',
    stat: '150+',
    description: 'switch_5_description',
    iconPath: 'M12 2a10 10 0 100 20 10 10 0 000-20zM2 12h20M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z',
    color: ACCENT_BLUE,
  },
] as const;

export const FAQ_ITEMS = [
  { q: 'faq_0_q', a: 'faq_0_a' },
  { q: 'faq_1_q', a: 'faq_1_a' },
  { q: 'faq_2_q', a: 'faq_2_a' },
  { q: 'faq_3_q', a: 'faq_3_a' },
  { q: 'faq_4_q', a: 'faq_4_a' },
] as const;

export const PROOF_BARS = [
  { label: 'proof_ping', before: 85, after: 12, unit: 'ms' },
  { label: 'proof_fps', before: 45, after: 120, unit: 'fps' },
  { label: 'proof_packet_loss', before: 8, after: 0, unit: '%' },
  { label: 'proof_jitter', before: 45, after: 1, unit: 'ms' },
] as const;

export const GAME_CAROUSEL = [
  { name: 'Valorant', image: '/images/Valorant.webp' },
  { name: 'CS2', image: '/images/CS2.webp' },
  { name: 'Fortnite', image: '/images/Fortnite.webp' },
  { name: 'Dota 2', image: '/images/Dota2.webp' },
  { name: 'World of Warcraft', image: '/images/World of Warcraft.webp' },
  { name: 'Final Fantasy XIV', image: '/images/Final Fantasy XIV.webp' },
  { name: 'Rainbow Six Siege', image: '/images/Rainbow Six Siege.png' },
  { name: 'Escape From Tarkov', image: '/images/Escape From Tarkov.webp' },
  { name: 'Ragnarok', image: '/images/Ragnarok.webp' },
  { name: 'Tibia', image: '/images/Tibia.png' },
  { name: 'Warface', image: '/images/Warface.png' },
  { name: 'StarCraft', image: '/images/StarCraft.webp' },
  { name: 'Albion Online', image: '/images/Albion.png' },
  { name: 'Lineage II', image: '/images/Lineage II.webp' },
] as const;
